import { useQuery } from '@tanstack/react-query'
import { useAccessToken } from '@/features/auth/state/auth'
import api from '@/lib/api'
import { TypeCargo } from '@/lib/enums'

type PermissionUserInfo = {
  id: string
  id_user: string
  name: string
  email: string
  tel?: string | null
  whatsApp?: string | null
  typeCargo: TypeCargo
  typeUser: string
  isActive: boolean
  id_tenant?: string | null
  activePerms: string[]
}

export function useFetchPermissionsByService(typeService?: string, typeCargo?: string) {
  const token = useAccessToken()

  return useQuery<PermissionUserInfo[]>({
    queryKey: ['permissions', typeService, typeCargo],
    queryFn: async () => {
      if (!typeService) throw new Error('Serviço não fornecido')

      try {
        const url = `/permissions/user-services/${typeService}${typeCargo ? `?typeCargo=${typeCargo}` : ''}`

        const response = await api.get(url, {
          headers: { Authorization: `Bearer ${token}` }
        })

        return response.data?.data ?? []
      } catch (error: any) {
        if (error.response?.status === 404) {
          throw new Error(
            `Nenhum usuário encontrado para o serviço ${typeService}${typeCargo ? ` e cargo ${typeCargo}` : ''}`
          )
        }

        console.error('Erro ao buscar permissões:', error)
        throw new Error('Erro inesperado ao buscar permissões')
      }
    },
    enabled: Boolean(token && typeService)
  })
}
